
import { months } from '@/modules/Territories'
import { mapActions } from 'vuex'
import { veeValidator } from '../../mixins/veeValidator'

export default {
  name: 'PaymentResubmitDialog',
  mixins: [veeValidator],
  props: {
    showResubmitModal: {
      required: true,
      type: Boolean
    },
    uid: {
      required: true,
      type: String
    },
    productId: {
      required: true,
      type: Number
    },
    quantity: {
      required: true,
      type: Number
    },
    tila: {
      required: false,
      type: Object,
      default: null
    },
    name: {
      required: false,
      type: String,
      default: ''
    }
  },
  data() {
    return {
      isHidden: true,
      creditCardInfo: {
        number: '',
        expiresOnMonth: '',
        expiresOnYear: '',
        CVV2: ''
      }
    }
  },
  computed: {
    expirationYears: function() {
      let currentYear = new Date().getFullYear()
      const year = currentYear
      const years = []
      while (currentYear <= year + 10) {
        years.push({
          text: currentYear,
          value: currentYear.toString().substr(-2)
        })
        currentYear++
      }
      return years
    },
    expirationMonths: function() {
      const date = new Date()
      return months.map(m => {
        m.disabled =
          this.creditCardInfo.expiresOnYear ===
            date
              .getFullYear()
              .toString()
              .slice(-2) && +m.value <= date.getMonth()
        return m
      })
    }
  },
  methods: {
    closeModal() {
      this.$bus.$emit('closeResubmitDialog', { hideError: false })
    },
    reSubmitOrder(TILAAgreement) {
      this.$validator.validateAll().then(success => {
        if (success) {
          const purchaseDetails = {
            productId: this.productId,
            quantity: this.quantity,
            resubmit: true,
            creditCardInfo: this.creditCardInfo
          }
          purchaseDetails.creditCardInfo.number = purchaseDetails.creditCardInfo.number.replace(
            /-/g,
            ''
          )
          if (typeof TILAAgreement !== 'undefined') {
            Object.assign(purchaseDetails, TILAAgreement)
          }
          this.purchase(purchaseDetails).then(({ errorCode }) => {
            if (errorCode) {
              this.isHidden = false
            } else {
              this.$bus.$emit('closeResubmitDialog', { hideError: true })
            }
          })
        }
      })
    },
    ...mapActions({
      nextStep: 'nextStep',
      purchase: 'purchase'
    })
  }
}
